import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';
import { DropzoneUpload } from './InputRenderer';

const DocketDocsDialog = ({
  isLoading = false,
  files,
  docsDialogOpen,
  handleDocsDialog,
  handleFileChange,
  handleDeleteFiles,
  viewFile,
  docType,
}) => {
  return (
    <Dialog maxWidth="md" fullWidth open={docsDialogOpen} onClose={handleDocsDialog} disableAutoFocus disableEnforceFocus>
      <DialogTitle>
        <Typography style={{ fontSize: '1.5rem' }} component="div">
          Documents
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Grid item xs={12} md={6}>
          <DropzoneUpload label="" onFileSelect={handleFileChange('files')} multiple={true} />
          <Box
            sx={{
              display: 'flex',
              overflowX: 'auto',
              gap: 1,
              py: 1,
              px: 0.5,
              alignItems: 'center',
              minHeight: 60,
            }}>
            {isLoading ? (
              <Box sx={{ display: 'flex' }}>
                <CircularProgress size={22} />
                <Typography style={{ marginLeft: 8 }}>Fetching Docs ...</Typography>
              </Box>
            ) : files && files.length > 0 ? (
              files.map(
                (file, index) =>
                  file.docType === docType && (
                    <Tooltip title={file.documentName} key={index}>
                      <div>
                        <Chip
                          label={file.documentName.length > 20 ? file.documentName.slice(0, 18) + '…' : file.documentName}
                          color="success"
                          sx={{
                            fontSize: '0.7rem',
                            height: '24px',
                            px: 1,
                          }}
                          onDelete={() => handleDeleteFiles(file)}
                          onClick={() => viewFile(file)}
                        />
                      </div>
                    </Tooltip>
                  ),
              )
            ) : (
              <Typography>No files uploaded.</Typography>
            )}
          </Box>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleDocsDialog}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocketDocsDialog;
